export enum ModalUrls {
  Parents = '#parents',
  Players = '#players',
  Player = '#player',
  Academies = '#academies'
}
